import { CrudRouter, DataList, SimpleUploader, Tree, AutoRouter } from "javaee-fre";
import { orgTree, regionTree } from "./comm-func.js";

const OrgExportSetting = () => import("../views/org-export-setting.vue");
const routers = [{
    path: 'home/admin/my/tenant/org', component: AutoRouter, meta() {
        let self = this, a = self.$store.state.account, isTenantSuper = self.$isInRole('ROLE_TENANT_SUPER'), lacts = [{
            label: '设置区县', icon: 'add_location', func(cfg) {
                let self = this;
                if (self.$store.state.loading.show) {
                    self.$status('请稍后设置～', 'error');
                    return;
                }
                self.$dialog.component(`选择区县 - ${cfg.item.name}`, Tree, { width: 400, ...regionTree() }, [
                    {
                        label: '确认设置', color: 'primary', func(sel) {
                            if (!sel || !sel.id) { return }
                            self.$loading('正在设置区县，请不要做其他操作～');
                            self.$axios.get(`/home/admin/my/tenant/org/region/${cfg.item.id}/${sel.id}`).then(() => {
                                self.$loading();
                                self.$status('设置成功～', 'success');
                                self.refresh();
                            });
                        }
                    }
                ]);
            }
        }, {
            label: '取消区县设置', icon: 'location_off', func(cfg) {
                let self = this;
                self.$axios.get(`/home/admin/my/tenant/org/region/${cfg.item.id}/_`).then(() => {
                    self.refresh();
                });
            }
        }];
        if (isTenantSuper || self.$isInRole('ROLE_TENANT_ACC')) {
            lacts.push({
                label: '管理员分配', icon: 'perm_identity', func(cfg) {
                    this.$dialog.crud(`管理员分配 - ${cfg.item.name}`, {
                        url: '/home/admin/my/tenant/acc', params: {
                            _org: cfg.item.id
                        }, listItemActions: [{
                            label: '修改密码', icon: 'vpn_key', func(cfg) {
                                this.$parent.onEdit(cfg.item.id, { _chgpwd: true });
                            }
                        }, {
                            label: '以此账号切换到该机构', icon: 'link', func(cfg2) {
                                let self = this;
                                self.$axios.get(`/home/my/tenant/org/change/${cfg.item.id}?_aid=${cfg2.item.id}`).then(r => {
                                    if (r.data && r.data.status == "ok") {
                                        let { tid } = self.$query();
                                        window.location = "/s/a/index.html" + (tid ? `?tid=${tid}` : '');
                                    }
                                });
                            }
                        }, {
                            label: '解除登录锁定', icon: 'lock_open', func(cfg2) {
                                let self = this;
                                self.$axios.get(`/home/admin/my/tenant/acc/unlock/${cfg2.item.id}?_org=${cfg.item.id}`).then(() => {
                                    self.refresh();
                                });
                            }
                        }],
                        listItemFilter(i, acts) {
                            if (!i.lock) {
                                this.delAction(acts, "icon", "lock_open");
                            }
                            return acts;
                        }
                    });
                }
            });
        }
        if (isTenantSuper || self.$isInRole('ROLE_CHG_ORG')) {
            lacts.push({
                label: '切换到该机构', icon: 'link', func(cfg) {
                    let self = this;
                    self.$axios.get(`/home/my/tenant/org/change/${cfg.item.id}`).then(r => {
                        if (r.data && r.data.status == "ok") {
                            let { tid } = self.$query();
                            window.location = "/s/a/index.html" + (tid ? `?tid=${tid}` : '');
                        }
                    });
                }
            });
        }
        if (self.$isSuperman()) {
            lacts.push({
                label: '其它自定义设置', icon: 'more_horiz', func(cfg) {
                    this.$parent.onEdit(cfg.item.id, { _ext: true });
                }
            }, {
                label: '移动机构', icon: 'swap_vert', func(cfg) {
                    let self = this;
                    self.$dialog.component(`选择机构 - ${cfg.item.name}`, Tree, {
                        width: 300, filter: function (i) {
                            return cfg.item.id == i.id;
                        }, ...orgTree()
                    }, [
                        {
                            label: '确认移动', func(sel) {
                                let id = 0;
                                if (sel && sel.actived) {
                                    id = sel.actived.id;
                                }
                                self.$axios.get(`/home/admin/my/tenant/org/move/${cfg.item.id}/${id}`).then(r => {
                                    if (r.data.status == 'ok') {
                                        self.refresh();
                                        self.$status('移动成功～', 'success');
                                    } else {
                                        self.$status(r.data.message | '移动出现错误！', 'error');
                                    }
                                });
                            }
                        }
                    ]);
                }
            }, {
                label: '刷新机构统计', icon: 'refresh', func(cfg) {
                    let self = this;
                    self.$loading('正在刷新计算不要做其它操作～');
                    self.$axios.get(`/home/admin/my/tenant/org/refresh/summary/${cfg.item.id}`).then(() => {
                        self.refresh();
                        self.$status('刷新成功～','success');
                        self.$loading();
                    });
                }
            }, {
                label: '设置微信模版消息', icon: 'add_alarm', func(cfg) {
                    let self = this
                    self.$dialog.crud('设置微信模版消息模版', {
                        width: 600,
                        url: '/home/admin/sys/alert/wx/msg/tmpl', forceEditFormStretch: true, targetId: '0', params: { _tid: a.tenantId, _orgId: cfg.item.id }, editable: true, initPanel: 'edit', desc: '需设置微信服务号相关信息后才能生效', onSaveSuccess() {
                            self.$dialog.close()
                            self.$status('设置成功～', 'success')
                        }
                    });
                }
            });
        }
        if (a.orgId == 0) {
            lacts.push({
                label: '启用导出试卷', confirm: '确定启用吗？', icon: 'print', func(cfg) {
                    let self = this;
                    self.$axios.get(`/home/admin/my/tenant/org/export/paper/${cfg.item.id}/${cfg.item.exportPaper === false ? true : false}`).then((r) => {
                        if (r.data && r.data.status == 'ok') {
                            self.$status('操作成功！', 'success');
                            self.refresh();
                            return;
                        }
                        self.$status(r.data && r.data.message ? r.data.message : '出现错误', "error");
                    });
                }
            });
        }
        let gacts = [{
            label: '设置区县', whereSel: true, func() {
                let self = this, sels = Object.keys(self.selected());
                if (self.$store.state.loading.show) {
                    self.$status('请稍后设置～', 'error');
                    return;
                }
                self.$dialog.component('选择区县', Tree, { width: 400, ...regionTree() }, [
                    {
                        label: '确认设置', color: 'primary', func(sel) {
                            if (!sel || !sel.id) { return }
                            self.$loading('正在设置区县，请不要做其他操作～');
                            self.$axios.get(`/home/admin/my/tenant/org/region/${sels.join('_')}/${sel.id}`).then(() => {
                                self.$loading();
                                self.$status('设置成功～', 'success');
                            });
                        }
                    }
                ]);
            }
        }, {
            label: '取消区县设置', whereSel: true, func() {
                let self = this, sels = Object.keys(self.selected());
                if (sels && sels.length > 0) {
                    self.$axios.get(`/home/admin/my/tenant/org/region/${sels.join('_')}/_`).then(() => {
                        self.refresh();
                    });
                }
            }
        }, {
            label: '设置分类', whereSel: true, func() {
                let self = this, sels = Object.keys(self.selected());
                self.$axios.get('/home/admin/my/tenant/org/dict/tagId').then(r => {
                    if (r.data.status != 'ok' || !r.data.message || r.data.message.length == 0) {
                        self.$status('没有机构分类');
                        return;
                    }
                    self.$dialog.select('选择分类', { width: 400, items: r.data.message, itemLabel: 'label', itemVal: 'val' }, [{
                        label: '确认', color: 'primary', func(tagId) {
                            if (tagId) {
                                self.$axios.get(`/home/admin/my/tenant/org/tag/${sels.join('_')}/${tagId}`).then(() => {
                                    self.$status('设置成功～', 'success');
                                });
                            }
                        }
                    }]);
                });
            }
        }];
        if (a.orgId == 0) {
            gacts.push({
                order: -10,
                label: '分组管理', func() {
                    this.$router.push('/console/home/admin/my/tenant/org/group');
                }
            }, {
                order: -11,
                label: '添加到分组', whereSel: true, func() {
                    let self = this, sels = Object.keys(self.selected());
                    self.$dialog.crud('选择分组',
                        {
                            url: '/home/admin/my/tenant/org/group', selectStyle: 'single',
                            createable: false, editable: false, deleteable: false
                        }, [{
                            label: '确认', color: 'primary', func(sel) {
                                if (!sel) return;
                                let ids = Object.keys(sel);
                                if (ids.length == 0) return;
                                self.$axios.get(`/home/admin/my/tenant/org/group/item/add/${sels.join('_')}`, { params: { _gId: ids[0] } }).then(r => {
                                    if (r.data && r.data.status == 'ok') {
                                        self.$status('添加成功～', 'success');
                                    } else {
                                        self.$status(r.data.message | '添加出现错误！', 'error');
                                    }
                                });
                            }
                        }]);
                }
            });
        }
        let crud = {
            selectStyle: a.orgId == 0 ? 'multi' : '',
            listItemSelectFilter(i) {
                return i.type && i.type.value == 1;
            },
            listItemActions: lacts,
            listActions: [...gacts, {
                label: '导出', func() {
                    let self = this;
                    self.$dialog.component('导出设置', OrgExportSetting, { width: 600 }, [{
                        label: '确认', func(c) {
                            let url = `${self.$const.baseUrl}/home/admin/my/tenant/org/export?_pid=0&_tree=${c.exportTree == '1' ? true : false}`;
                            if (c.useSearch == '1') {//按照搜索导出
                                url = `${url}&${self.$qs.stringify(self.searchData())}`;
                            }
                            window.open(url);
                        }
                    }]);
                }
            }],
            listItemFilter(i, acts) {
                let isSuper = this.$isSuperman();
                if (!isSuper) {
                    this.delAction(acts, "icon", "print");
                } else if (i.exportPaper === true) {
                    let act = acts.find(a => a.icon == "print");
                    act.icon = "print_disabled";
                    act.label = "关闭导出试卷";
                    act.confirm = '确定关闭吗？';
                }
                if (this.$dictVal(i.type) !== 1) {
                    this.delAction(acts, "icon", "add_location");
                    this.delAction(acts, "icon", "refresh");
                    this.delAction(acts, "icon", "location_off");
                } else {
                    if (i.region) {
                        let act = acts.find(a => a.icon == "add_location");
                        act.icon = 'place';
                        act.label = '修改区县';
                    } else {
                        this.delAction(acts, "icon", "location_off");
                    }
                }
                return acts;
            }
        };
        if (a.orgType != 1) {
            return {
                tree: orgTree(true),
                acceptEmptyActive: true,
                crud(i, tree) {
                    let acts = [...gacts, {
                        label: '导出', func() {
                            let self = this;
                            self.$dialog.component('导出设置', OrgExportSetting, { width: 650 }, [{
                                label: '确认', func(c) {
                                    let url = `${self.$const.baseUrl}/home/admin/my/tenant/org/export?_pid=${i ? i.id : 0}&_tree=${c.exportTree == '1' ? true : false}`;
                                    if (c.useSearch == '1') {//按照搜索导出
                                        url = `${url}&${self.$qs.stringify(self.searchData())}`;
                                    }
                                    window.open(url);
                                }
                            }]);
                        }
                    }];
                    if (!i || i.type != 1) {
                        acts.push({
                            label: '导入', confirm: `确认导入到${i ? i.name : '根机构'}下？`, func() {
                                let self = this;
                                self.$dialog.component(`导入机构到${i ? i.name : '根机构'}`, SimpleUploader, {
                                    width: 600,
                                    persist: true,
                                    url: `/home/admin/my/tenant/org/import${i ? ('?_pid=' + i.id) : ''}`,
                                    templateUrl: '/s/a/org_import.xlsx',
                                    onUploadComplete(r) {
                                        if (r.data && r.data.status == 'ok') {
                                            self.$dialog.close();
                                            self.$status('导入成功！', 'success');
                                            tree.refreshActive();
                                            self.refresh();
                                        } else {
                                            let err = r.data ? r.data.message : '导入出现错误';
                                            if (typeof err == 'string') {
                                                self.$status(err, 'error');
                                            } else {
                                                //弹出一个对话框，列出导入的错误列表
                                                self.$dialog.component('导入错误信息', DataList, {
                                                    width: 600,
                                                    heads: [{ label: '行', name: 'row' }, { label: '列', name: 'col' }, { label: '说明', name: 'message' }],
                                                    data: r.data.message
                                                });
                                            }
                                        }
                                    }
                                });
                            }
                        });
                    }
                    return {
                        ...crud,
                        listActions: acts
                    };
                }
            };
        } else {
            return crud;
        }
    },
    children: [{
        path: 'group', component: CrudRouter, meta: {
            name: '分组管理',
            forceEditFormStretch: true,
            url: '/home/admin/my/tenant/org/group',
            listItemActions: [
                {
                    label: '企业', icon: 'list', func(cfg) {
                        this.$dialog.crud('机构', { params: { _gId: cfg.item.id }, url: '/home/admin/my/tenant/org/group/item' });
                    }
                }
            ]
        }
    }]
},
{
    path: 'home/admin/my/tenant/org_tag', component: CrudRouter, meta: {}
}];
export default {
    routers: routers
}